import React from "react";
import styled from "styled-components";
import { Paper } from "@mui/material";

import { Black } from "../theme/colors";

export const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.$background};
  padding-bottom: 50px;
`;

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Body = styled.div`
  margin-top: 65px;
  margin-bottom: 100px;
  overflow-x: hidden;
`;

export const Section = styled.div`
  min-height: 25vh;
  padding: 50px 10px 50px;
`;

export const StickyFooter = styled(Paper)`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10; /* Ensure it stays above other elements */
`;

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

function LayoutOnboarding(props) {
  if (!isMobile) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
          color: "white",
          fontFamily: "Satoshi-Variable",
          textAlign: "center",
          padding: "20px",
        }}
      >
        This app is currently only available on mobile devices. Please open it
        on your phone.
      </div>
    );
  }

  return (
    <Wrapper $background={props.$background || Black}>
      <StyledLayout>
        <Body>{props.children}</Body>
      </StyledLayout>
    </Wrapper>
  );
}

export default LayoutOnboarding;
